export const PROJECT_PAGE_DEFAULT_SETTINGS = {
    isFullWidth    : false,
}